const selectLoader = (state) => state.mailboxes.management.loader
const selectError = (state) => state.mailboxes.management.error
const selectData = (state) => state.mailboxes.management.data
const selectSelectedMailboxesMap = (state) => state.mailboxes.management.selectedMailboxesMap
const selectLoaderMailboxesMap = (state) => state.mailboxes.management.loaderMailboxesMap
const selectSortProperty = (state) => state.mailboxes.management.sortProperty
const selectTypeFilter = (state) => state.mailboxes.management.typeFilter
const selectProtectedFilter = (state) => state.mailboxes.management.protectedFilter
const selectManagementTags = (state) => state.mailboxes.management.tags
const selectManagementTagsSearch = (state) => state.mailboxes.management.tags.search
const selectManagementTagsPage = (state) => state.mailboxes.management.tags.page
const selectTagsFilter = (state) => state.mailboxes.management.tagsFilter
const selectTagsLoader = (state) => state.mailboxes.management.tagsFilterLoader
const selectSegments = (state) => state.mailboxes.management.segments
const selectSegmentsFilter = (state) => state.mailboxes.management.segmentsFilter

const selectRiskLevelsFilter = (state) => state.mailboxes.management.riskLevelsFilter
const selectPage = (state) => state.mailboxes.management.page
const selectAddMailboxStatus = (state) => state.mailboxes.management.addMailboxStatus
const selectAddMailboxLoader = (state) => state.mailboxes.management.addMailboxLoader
const selectSelectAllStatus = (state) => state.mailboxes.management.selectAll
const selectComplianceReportData = (state) => state.mailboxes.management.complianceReportData

export {
  selectLoader,
  selectError,
  selectData,
  selectSelectedMailboxesMap,
  selectLoaderMailboxesMap,
  selectSortProperty,
  selectTypeFilter,
  selectProtectedFilter,
  selectTagsFilter,
  selectSegments,
  selectSegmentsFilter,
  selectRiskLevelsFilter,
  selectPage,
  selectAddMailboxStatus,
  selectAddMailboxLoader,
  selectSelectAllStatus,
  selectComplianceReportData,
  selectTagsLoader,
  selectManagementTags,
  selectManagementTagsSearch,
  selectManagementTagsPage,
}
